/* eslint-disable */
import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
import makeStyles from "@mui/styles/makeStyles";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
// @mui/icons-material
import Favorite from "@mui/icons-material/Favorite";
import styles from "../../styles/jss/nextjs-material-kit-pro/components/footerStyle.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const useStyles = makeStyles(styles);
export default function Footer(props) {
  const {
    children,
    content,
    theme,
    big,
    className,
    banner,
    ...rest
  } = props;
  const classes = useStyles();
  const themeType = theme === "transparent" || theme == undefined ? false : true;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes[theme]]: themeType,
    [classes.big]: big || children !== undefined,
    [className]: className !== undefined
  });
  const aClasses = classNames({
    [classes.a]: true
  });
  return /*#__PURE__*/_jsx("footer", {
    className: footerClasses,
    ...rest,
    children: /*#__PURE__*/_jsxs("div", {
      className: classes.container,
      children: [banner ? /*#__PURE__*/_jsx("div", {
        style: {
          width: "100%"
        },
        children: banner
      }) : null, /*#__PURE__*/_jsx("hr", {}), children !== undefined ? /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("div", {
          className: classes.content,
          children: children
        }), /*#__PURE__*/_jsx("hr", {})]
      }) : " ", content, /*#__PURE__*/_jsx("div", {
        className: classes.clearFix
      })]
    })
  });
}
Footer.propTypes = {
  theme: PropTypes.oneOf(["dark", "white", "transparent"]),
  big: PropTypes.bool,
  content: PropTypes.node.isRequired,
  banner: PropTypes.node
};